var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4911 1.33597C18.5623 1.74906 19.9231 9.64164 19.9231 12.6563C19.9231 17.253 17.4505 20.5313 13.795 21.8496L14.9423 42.7764C15.0046 43.9805 14.0351 45 12.8077 45H7.11538C5.89687 45 4.91851 43.9893 4.98077 42.7764L6.12812 21.8496C2.4637 20.5313 0 17.2442 0 12.6563C0 9.63285 1.36082 1.74906 1.43197 1.33597C1.71659 -0.448208 5.46106 -0.474576 5.69231 1.43265V13.8428C5.80793 14.1416 7.03534 14.1241 7.11538 13.8428C7.2399 11.6192 7.81803 1.60843 7.82692 1.37992C8.12043 -0.448208 11.8026 -0.448208 12.0873 1.37992C12.105 1.61722 12.6743 11.6192 12.7988 13.8428C12.8788 14.1241 14.1151 14.1416 14.2219 13.8428V1.43265C14.4531 -0.465786 18.2065 -0.448208 18.4911 1.33597ZM29.093 26.4463L27.7589 42.7149C27.6522 43.9454 28.6394 45 29.8846 45H34.8654C36.0483 45 37 44.0596 37 42.8907V2.10941C37 0.949253 36.0483 3.40654e-05 34.8654 3.40654e-05C27.5276 3.40654e-05 15.1736 15.6885 29.093 26.4463Z",
    fill: "#AD4D34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_2082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/foodIcon.d6fc121a12c3a6ca7f3a47d3ea30e3e2.svg";
export { ForwardRef as ReactComponent };